export default __webpack_public_path__ + "static/media/dream_job_icon.818e0d66.png";